var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 12.5625C27.947 12.5625 22.6215 14.7684 18.695 18.695C14.7684 22.6215 12.5625 27.947 12.5625 33.5C12.5625 39.053 14.7684 44.3785 18.695 48.305C22.6215 52.2316 27.947 54.4375 33.5 54.4375C39.053 54.4375 44.3785 52.2316 48.305 48.305C52.2316 44.3785 54.4375 39.053 54.4375 33.5C54.4375 27.947 52.2316 22.6215 48.305 18.695C44.3785 14.7684 39.053 12.5625 33.5 12.5625ZM4.1875 33.5C4.1875 17.3111 17.3111 4.1875 33.5 4.1875C49.6889 4.1875 62.8125 17.3111 62.8125 33.5C62.8125 49.6889 49.6889 62.8125 33.5 62.8125C17.3111 62.8125 4.1875 49.6889 4.1875 33.5Z",
    fill: "#567BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 12.5625C28.102 12.551 22.9104 14.6358 19.0196 18.3775C18.2136 19.1228 17.1472 19.5217 16.0499 19.4885C14.9527 19.4552 13.9123 18.9924 13.1529 18.1997C12.3935 17.407 11.9758 16.3478 11.9896 15.2501C12.0035 14.1524 12.4478 13.1041 13.2269 12.3308C14.459 11.149 15.7878 10.0807 17.2134 9.12596C22.0315 5.8992 27.7012 4.18002 33.5 4.1875C34.6106 4.1875 35.6757 4.62868 36.461 5.41399C37.2463 6.1993 37.6875 7.26441 37.6875 8.375C37.6875 9.48559 37.2463 10.5507 36.461 11.336C35.6757 12.1213 34.6106 12.5625 33.5 12.5625Z",
    fill: "#567BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.090ecaff890d9db82b482c581fc480e8.svg";
export { ForwardRef as ReactComponent };